module.exports = __webpack_public_path__ + "static/media/das_logo.99381f4a.png";